import type { SettingsResponse } from '@orbit-sync/shared-types';
import { request } from './client.js';

/**
 * `GET /api/v1/settings` - the administrator's limits and switches.
 *
 * Public, so the sign-up form can show the password policy before there is an
 * account. The client uses these to fail early and explain the rule; the server
 * enforces them regardless.
 */
export function getSettings(signal?: AbortSignal): Promise<SettingsResponse> {
  return request<SettingsResponse>('/settings', { authenticated: false, signal });
}
